import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginationInputType } from '@/gql/graphql';
import type { PaginatedDeliveryOrderResponse } from '@/models/gourmet';

// Fragments
import './fragments/multiOrderPartialFragment';

export const getUnresolvedOrders = async (pagination: PaginationInputType) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      pagination,
    },
    query: graphql(`
      query getUnresolvedOrders($pagination: PaginationInputType!) {
        getUnresolvedOrders(pagination: $pagination) {
          ...MultiOrderPartialFragment
        }
      }
    `),
  });

  return response.data.getUnresolvedOrders as PaginatedDeliveryOrderResponse;
};
